/*
 * @Author: Wang hui
 * @Date: 2021-04-30 14:17:22
 * @LastEditTime: 2021-05-07 10:27:10
 * @LastEditors: Please set LastEditors
 * @Description: common
 * @FilePath: \Wjb-Website\src\store\modules\common.js
 */
export default {
    //不同页面中引入getter、actions、mutations时，需要加上所属的模块名
    namespaced: true,
    state: {
        includeList: ['home'],
        screenWidth: document.body.clientWidth,
    },
    mutations: {
        //   动态添加缓存页面
        ADD_INCLUDE(state, preload) {
            !state.includeList.includes(preload) &&
                state.includeList.push(preload)
        },
        //   动态删除缓存页面
        DEL_INCLUDE(state, preload) {
            state.includeList.includes(preload) &&
                state.includeList.splice(state.includeList.indexOf(preload), 1);
        },
        CHANGE_WIDTH(state, preload) {
            state.screenWidth = preload
        }
    }
};